module.exports = __webpack_public_path__ + "img/4.c791c3d8.jpg";